import { useState, useEffect } from 'react';
import Button from '@mui/joy/Button';
// import Dialog from '@mui/joy/Dialog';
import DialogActions from '@mui/joy/DialogActions';
import DialogContent from '@mui/joy/DialogContent';
// import DialogContentText from '@mui/joy/DialogContentText';
import DialogTitle from '@mui/joy/DialogTitle';
import { useLocation } from 'react-router';
import { usePrevious } from 'react-use';
import { FormControl, FormLabel, Input, Modal, ModalClose, ModalDialog, Textarea, Typography } from '@mui/joy';

const TextField = ({ minRows, multiline, ...props }) => (
  <FormControl>
    <FormLabel>{props.label}</FormLabel>
    {multiline ? <Textarea minRows={minRows} {...props} /> : <Input {...props} />}
  </FormControl>
)

const FeedbackDialog = ({ open, handleClose, handleSubmit, title, text, fullWidth = false, maxWidth = 'sm', fullScreen = false,
  input = {}, inputs = [], isAlert, confirmButtonText, component, /* scroll = "paper", */ clickAwayClose = false, removePadding = false, level,
  closeOnPathChange = true }) => {
  const [value, setValue] = useState('');
  const { pathname } = useLocation();

  const handleOk = e => {
    e.preventDefault();
    setValue('');
    handleSubmit((input.title || inputs.length > 0) ? value : true);
  }

  useEffect(() => {
    if (input.initialValue !== undefined)
      setValue(input.initialValue);
  }, [input.initialValue]);

  useEffect(() => {
    if (inputs.length === 0)
      return;
    const state = Object.fromEntries(inputs.map(x => [x.name, x.initialValue || ""]));
    setValue(state);
  }, [inputs]);

  const prevPath = usePrevious(pathname);
  useEffect(() => {
    // console.log("effect", closeOnPathChange, pathname, prevPath, pathname !== prevPath)
    if (closeOnPathChange && pathname && pathname !== prevPath)
      handleSubmit(true);
  }, [pathname, closeOnPathChange, handleSubmit, prevPath]);

  return (
    <Modal
      open={open}
      // aria-labelledby="alert-dialog-title"
      // aria-describedby="alert-dialog-description"
      // fullWidth={fullWidth}
      onClose={clickAwayClose ? handleOk : undefined}
    // scroll={scroll}
    // style={{ zIndex: 2000 }}
    // disableScrollLock
    >
      <ModalDialog
        sx={{ width: fullWidth ? '100%' : 'auto' }}
        maxWidth={maxWidth}
        layout={fullScreen ? "fullscreen" : undefined}
      >
        {/* {fullScreen && <CloseButton onClick={handleOk} />} */}
        {fullScreen && <ModalClose onClick={handleOk} />}
        {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
        <DialogContent style={removePadding ? { padding: '0', } : undefined} sx={{ pt: 1 }}>
          {text && (typeof text === 'string' ?
            <Typography id="modal-desc" textColor="text.tertiary" sx={{ whiteSpace: 'pre-line' }}>
              {text}
            </Typography>
            : text)
          }
          {component ? component : null}
          <form onSubmit={handleOk} id={"form-dialog-form-" + level}>
            {input.title &&
              <TextField
                autoFocus
                margin="dense"
                label={input.title}
                // fullWidth
                type={input.type || "text"}
                name={input.name || "form-dialog-input"}
                multiline={input.rows > 1}
                minRows={input.rows}
                variant={input.variant}
                value={value}
                onChange={e => setValue(e.target.value)}
                required={!!input.required}
              />
            }
            {inputs.map((input, index) => (
              <TextField
                key={input.name}
                autoFocus={index === 0}
                margin="dense"
                label={input.title}
                // fullWidth
                value={value[input.name] || ""}
                onChange={({ target }) => setValue(x => ({ ...x, [input.name]: target.value }))}
                type={input.type}
                disabled={input.disabled}
                required={!!input.required}
              />
            ))}
          </form>
        </DialogContent>
        <DialogActions>
          <Button type="submit" form={"form-dialog-form-" + level}>
            {confirmButtonText || "OK"}
          </Button>
          {(!isAlert && !component) &&
            <Button onClick={handleClose}>
              Cancel
            </Button>
          }
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
}

export default FeedbackDialog;
